import { Box, Typography } from "@mui/material";

export const InfoBox = ({ label, value, gridColumn }) => (
  <Box display="flex" flexDirection="column" gap="5px" sx={{ flexGrow: 1, gridColumn }}>
    <Typography
      component="p"
      sx={{ fontSize: "12px", fontWeight: 700, fontFamily: "Helvetica" }}
    >
      {label}
    </Typography>
    <Typography
      component="p"
      sx={{ fontSize: "12px", fontFamily: "Helvetica" }}
    >
      {value}
    </Typography>
  </Box>
);
